module.exports = __webpack_public_path__ + "video-5bbb80295f9f95c87c3c.svg";